module.exports = __webpack_public_path__ + "static/media/lobby-card-programme.54d6723e.svg";